import React from 'react';

export const PageHeader = ({ title, description, actions, breadcrumbs }) => {
  return (
    <div className="mb-6">
      {breadcrumbs && (
        <div className="mb-2 flex items-center gap-2 text-sm text-muted-foreground">
          {breadcrumbs.map((crumb, index) => (
            <React.Fragment key={`breadcrumb-${crumb}-${index}`}>
              {index > 0 && <span>→</span>}
              <span className={index === breadcrumbs.length - 1 ? 'text-slate-900 font-medium' : ''}>
                {crumb}
              </span>
            </React.Fragment>
          ))}
        </div>
      )}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900">
            {title}
          </h1>
          {description && (
            <p className="mt-1 text-sm text-slate-600">{description}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-3">{actions}</div>}
      </div>
    </div>
  );
};
